const DELIVERY_APPROVALS_CHANGED_EVENT = 'attune:delivery-approvals-changed';
const WORKSPACE_APPROVAL_COUNT_UPDATED_EVENT = 'attune:workspace-approval-count-updated';
const pendingDeliveryApprovalProjectIds = new Set<string>();
const workspaceApprovalCounts = new Map<string, number>();
let deliveryApprovalsChangedTimer: number | null = null;

function flushDeliveryApprovalsChanged(): void {
  const projectIds = Array.from(pendingDeliveryApprovalProjectIds);
  pendingDeliveryApprovalProjectIds.clear();
  deliveryApprovalsChangedTimer = null;
  projectIds.forEach(projectId => {
    window.dispatchEvent(
      new CustomEvent(DELIVERY_APPROVALS_CHANGED_EVENT, {
        detail: { projectId },
      })
    );
  });
}

export function notifyDeliveryApprovalsChanged(projectId: string): void {
  if (typeof window === 'undefined') return;
  pendingDeliveryApprovalProjectIds.add(projectId);
  if (deliveryApprovalsChangedTimer !== null) {
    window.clearTimeout(deliveryApprovalsChangedTimer);
  }
  deliveryApprovalsChangedTimer = window.setTimeout(flushDeliveryApprovalsChanged, 50);
}

export function subscribeDeliveryApprovalsChanged(
  listener: (projectId: string) => void
): () => void {
  if (typeof window === 'undefined') return () => undefined;
  const handleChange = (event: Event) => {
    const projectId = (event as CustomEvent<{ projectId?: string }>).detail?.projectId;
    if (projectId) listener(projectId);
  };
  window.addEventListener(DELIVERY_APPROVALS_CHANGED_EVENT, handleChange);
  return () => window.removeEventListener(DELIVERY_APPROVALS_CHANGED_EVENT, handleChange);
}

export function publishWorkspaceApprovalPendingCount(projectId: string, count: number): void {
  if (typeof window === 'undefined') return;
  const normalizedCount = Math.max(0, Math.floor(Number(count) || 0));
  workspaceApprovalCounts.set(projectId, normalizedCount);
  window.dispatchEvent(
    new CustomEvent(WORKSPACE_APPROVAL_COUNT_UPDATED_EVENT, {
      detail: { projectId, count: normalizedCount },
    })
  );
}

export function getWorkspaceApprovalPendingCount(projectId: string): number | null {
  return workspaceApprovalCounts.get(projectId) ?? null;
}

export function subscribeWorkspaceApprovalPendingCount(
  listener: (projectId: string, count: number) => void
): () => void {
  if (typeof window === 'undefined') return () => undefined;
  const handleChange = (event: Event) => {
    const detail = (event as CustomEvent<{ projectId?: string; count?: number }>).detail;
    if (!detail?.projectId || !Number.isFinite(detail.count)) return;
    listener(detail.projectId, Math.max(0, Math.floor(detail.count || 0)));
  };
  window.addEventListener(WORKSPACE_APPROVAL_COUNT_UPDATED_EVENT, handleChange);
  return () => window.removeEventListener(WORKSPACE_APPROVAL_COUNT_UPDATED_EVENT, handleChange);
}
